// templateid: template_vxu3xlg
// service id : service_1cha7pm
//  publicKey: w2VZcg7J9zaHh3knW
import { useRef, useState } from "react";
import emailjs from '@emailjs/browser';

function ReportBug() {
  const formRef = useRef(null);
  const [alert, setAlert] = useState({})

  const handleForm = (e) => {
    e.preventDefault();

    const formContent = formRef.current;
    const fullname = formContent.fullname.value;
    const email = formContent.email.value;
    const message = formContent.message.value;

    if( !fullname || !email || !message ){
      setAlert({
        text: "Fields cannot be empty. Please, try again.",
        color: "#b91c1c",
        bg: "#fee2e2",
      });
      return;
    }

    emailjs.sendForm("service_1cha7pm", "template_vxu3xlg", formContent, "w2VZcg7J9zaHh3knW").then(() => {
      formContent.reset();
      setAlert({
        text: "Report Sent successfully",
        color: "#134e4a",
        bg: "#d5ffd5",
      });
    }, () => {
      setAlert({
        text: "OOPss!! Something went wrong. Please, try again",
        color: "#b91c1c",
        bg: "#fee2e2",
      });
    }
  )
  }

  return (
    <div className="bg-[#f8fafc] flex flex-col items-center text-xl min-h-screen pt-[15%] md:pt-[10%] px-5">
        
        <div className="border w-[100%] md:w-[45%] p-5 rounded-md border border-gray-300 shadow-xl/20">
          {alert && (
            <div className="font-semibold px-4 py-3 mb-3 rounded text-base text-center" 
            style={{
              backgroundColor: alert.bg,
              color: alert.color,
              border: `1px solid ${alert.color}`
            }}> {alert.text}</div>
          )}
          <h1 className="text-2xl md:text-4xl font-extrabold bg_Gradient bg-clip-text text-transparent mb-3" >
            Report An Issue
          </h1>
           <p className="text-[#65738a] text-base md:text-md font-semibold mb-10"> Describe the problem you have encountered. Please, be as specific as possible</p>

          <form ref={formRef} onSubmit={handleForm} className="space-y-4">
            <input type="text" name="fullname" placeholder="Enter your name" className="border bg-[#f8fafc] py-3 px-5 w-full h-10 rounded-md text-base border border-gray-300"/>
            <input type="text" name="email" placeholder="Enter Your Email" className="bg-[#f8fafc] py-3 px-5 w-full h-10 rounded-md text-base border border-gray-300"/>
            {/* <input type="textarea" placeholder="Enter the Issue here" className="bg-[#f8fafc] py-3 px-5 w-full h-10 rounded-md text-base border border-gray-300"/> */}
            <textarea placeholder="Enter the Problem here" name="message" rows={3} className="bg-[#f8fafc] py-3 px-5 w-full rounded-md text-base border border-gray-300">

            </textarea>
            <input type="submit" value="Report Problem" className="bg_Gradient px-5 mt-5 text-[white] pl-11 w-full h-10 rounded-md text-base font-semibold hover:shadow-xl/20 transition ease-in-out"/>
          </form>
        </div>

    </div>
  );
}

export default ReportBug;
